var map = {
	"./12.png": 7216,
	"./13.png": 6903,
	"./Alarm 2.mp3": 2007,
	"./Arrow Up.svg": 6990,
	"./Frame 26.png": 2398,
	"./Gallery.svg": 1723,
	"./Vector (Stroke).svg": 4843,
	"./Vector.png": 9214,
	"./arrowLeft.png": 1769,
	"./arrowRight.png": 2,
	"./arrowdown.png": 5588,
	"./backArrow.svg": 3352,
	"./backgrounds/backlogo.jpg": 5069,
	"./blue.gif": 6087,
	"./clear.png": 2005,
	"./delete.png": 1125,
	"./edit.png": 8975,
	"./five.png": 7239,
	"./floorImage.png": 3120,
	"./four.png": 9478,
	"./gray.gif": 7753,
	"./green.gif": 9990,
	"./green.png": 4306,
	"./image 1.png": 5334,
	"./image 1.svg": 1897,
	"./image 3.png": 8461,
	"./image 3.svg": 7177,
	"./image 4.svg": 3118,
	"./loading.gif": 6053,
	"./log_new.jpeg": 6191,
	"./logo.png": 6949,
	"./logout.png": 6645,
	"./mobilecss/style.css": 3548,
	"./new1.png": 8281,
	"./one.png": 1377,
	"./plus.png": 8859,
	"./popupDelete.png": 7340,
	"./purple.gif": 3038,
	"./red.gif": 5379,
	"./red.png": 9447,
	"./save.svg": 2700,
	"./search.svg": 1238,
	"./secplus.png": 1218,
	"./three.png": 5303,
	"./trash.svg": 9916,
	"./two.png": 2760,
	"./yellow.gif": 6889,
	"./yellow.png": 4774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;